import { attr, belongsTo } from '@ember-data/model';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
export const MAX_VENDOR_CODE_LENGTH = 550;
export default ItemsV3Base.extend({
  // sku is the seller-facing Vendor Code
  sku: attr('string'),
  price: attr('legacy-money'),
  vendor: belongsTo('squareup/inventory/v3/vendor', {
    async: false
  }),
  ordinal: attr('number'),
  itemVariation: belongsTo('item-variation', {
    async: false
  })
}).reopenClass({
  _modelNameForMigration: 'item-variation-vendor-info',
  catalogType() {
    return 'ITEM_VARIATION_VENDOR_INFO';
  }
});